webpackJsonp([79611799117203,60335399758886],{

/***/ 166:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(328);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(166);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 597:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserLinks = __webpack_require__(33);
	
	var _UserLinks2 = _interopRequireDefault(_UserLinks);
	
	var _SiteConfig = __webpack_require__(15);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	__webpack_require__(600);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Footer.prototype.render = function render() {
	    var userLinks = this.props.userLinks;
	    var copyright = _SiteConfig2.default.copyright,
	        fixedFooter = _SiteConfig2.default.fixedFooter;
	
	    if (!copyright) {
	      return null;
	    }
	    return _react2.default.createElement(
	      "footer",
	      { className: fixedFooter ? "footer footer-fixed" : "footer" },
	      userLinks ? _react2.default.createElement(_UserLinks2.default, { config: _SiteConfig2.default, labeled: true }) : null,
	      _react2.default.createElement(
	        "div",
	        { className: "notice-container" },
	        _react2.default.createElement(
	          "div",
	          { className: "copyright" },
	          _react2.default.createElement(
	            "h4",
	            null,
	            copyright
	          )
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react.Component);
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 600:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FontIcons = __webpack_require__(29);
	
	var _FontIcons2 = _interopRequireDefault(_FontIcons);
	
	var _gatsbyLink = __webpack_require__(26);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function GetNavList(config) {
	  var NavList = [{
	    primaryText: "松果网",
	    leftIcon: _react2.default.createElement(
	      _FontIcons2.default,
	      null,
	      "home"
	    ),
	    component: _gatsbyLink2.default,
	    to: "/"
	  }, {
	    divider: true
	  }];
	
	  if (config.userLinks) {
	    config.userLinks.forEach(function (link) {
	      NavList.push({
	        primaryText: link.label,
	        leftIcon: _react2.default.createElement(_FontIcons2.default, { forceSize: true, iconClassName: link.iconClassName }),
	        component: "a",
	        href: link.url
	      });
	    });
	  }
	
	  NavList.push({ divider: true });
	
	  NavList.push({
	    primaryText: "关于我们",
	    leftIcon: _react2.default.createElement(
	      _FontIcons2.default,
	      null,
	      "person"
	    ),
	    component: _gatsbyLink2.default,
	    to: "/about/"
	  });
	  return NavList;
	}
	exports.default = GetNavList;
	module.exports = exports["default"];

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NavigationDrawers = __webpack_require__(270);
	
	var _NavigationDrawers2 = _interopRequireDefault(_NavigationDrawers);
	
	var _ToolbarActions = __webpack_require__(325);
	
	var _ToolbarActions2 = _interopRequireDefault(_ToolbarActions);
	
	var _Footer = __webpack_require__(315);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _NavList = __webpack_require__(318);
	
	var _NavList2 = _interopRequireDefault(_NavList);
	
	__webpack_require__(602);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Navigation = function (_Component) {
	  _inherits(Navigation, _Component);
	
	  function Navigation() {
	    _classCallCheck(this, Navigation);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Navigation.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        config = _props.config,
	        LocalTitle = _props.LocalTitle;
	
	    var footerLinks = LocalTitle !== "About";
	    return _react2.default.createElement(
	      _NavigationDrawers2.default,
	      {
	        drawerTitle: config.siteTitle,
	        toolbarTitle: LocalTitle,
	        contentClassName: "main-content",
	        navItems: (0, _NavList2.default)(config),
	        mobileDrawerType: _NavigationDrawers2.default.DrawerTypes.TEMPORARY,
	        tabletDrawerType: _NavigationDrawers2.default.DrawerTypes.TEMPORARY,
	        desktopDrawerType: _NavigationDrawers2.default.DrawerTypes.TEMPORARY,
	        toolbarActions: _react2.default.createElement(_ToolbarActions2.default, { config: config })
	      },
	      _react2.default.createElement(
	        "div",
	        { className: "main-container" },
	        children
	      ),
	      _react2.default.createElement(_Footer2.default, { userLinks: footerLinks })
	    );
	  };
	
	  return Navigation;
	}(_react.Component);
	
	exports.default = Navigation;
	module.exports = exports["default"];

/***/ }),

/***/ 602:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserLinks = __webpack_require__(33);
	
	var _UserLinks2 = _interopRequireDefault(_UserLinks);
	
	__webpack_require__(607);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Toolbar = function (_Component) {
	  _inherits(Toolbar, _Component);
	
	  function Toolbar() {
	    _classCallCheck(this, Toolbar);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Toolbar.prototype.render = function render() {
	    var config = this.props.config;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "toolbar-actions" },
	      _react2.default.createElement(
	        "div",
	        { className: "userlinks-container" },
	        _react2.default.createElement(_UserLinks2.default, { config: config })
	      )
	    );
	  };
	
	  return Toolbar;
	}(_react.Component);
	
	exports.default = Toolbar;
	module.exports = exports["default"];

/***/ }),

/***/ 607:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Buttons = __webpack_require__(36);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	__webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserLinks = function (_Component) {
	  _inherits(UserLinks, _Component);
	
	  function UserLinks() {
	    _classCallCheck(this, UserLinks);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  UserLinks.prototype.getLinkElements = function getLinkElements() {
	    var userLinks = this.props.config.userLinks;
	    var labeled = this.props.labeled;
	
	    return userLinks.map(function (link) {
	      return _react2.default.createElement(
	        _Buttons2.default,
	        {
	          icon: !labeled,
	          flat: labeled,
	          secondary: true,
	          key: link.label,
	          iconClassName: link.iconClassName,
	          href: link.url
	        },
	        labeled ? link.label : ""
	      );
	    });
	  };
	
	  UserLinks.prototype.render = function render() {
	    var userLinks = this.props.config.userLinks;
	
	    if (!userLinks) {
	      return null;
	    }
	    return _react2.default.createElement(
	      "div",
	      { className: "user-links" },
	      this.getLinkElements()
	    );
	  };
	
	  return UserLinks;
	}(_react.Component);
	
	exports.default = UserLinks;
	module.exports = exports["default"];

/***/ }),

/***/ 51:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 609:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(16);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(597);
	
	var _Navigation = __webpack_require__(319);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _SiteConfig = __webpack_require__(15);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	__webpack_require__(610);
	
	__webpack_require__(609);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainLayout = function (_React$Component) {
	  _inherits(MainLayout, _React$Component);
	
	  function MainLayout() {
	    _classCallCheck(this, MainLayout);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  MainLayout.prototype.getLocalTitle = function getLocalTitle() {
	    function capitalize(string) {
	      return string.charAt(0).toUpperCase() + string.slice(1);
	    }
	    var pathPrefix = _SiteConfig2.default.pathPrefix ? _SiteConfig2.default.pathPrefix : "/";
	    var currentPath = this.props.location.pathname.replace(pathPrefix, "").replace("/", "");
	    var title = "";
	    if (currentPath === "") {
	      title = "松果网 ";
	    } else if (currentPath === "tags") {
	      title = "Tags";
	    } else if (currentPath === "categories") {
	      title = "Categories";
	    } else if (currentPath === "about") {
	      title = "About";
	    } else if (currentPath.includes("posts")) {
	      title = "Article";
	    } else if (currentPath.includes("tags")) {
	      var tag = currentPath.replace("tags", "").replace("/", "").replace("-", " ");
	      title = "Tagged in " + capitalize(tag);
	    } else if (currentPath.includes("categories")) {
	      var category = currentPath.replace("categories", "").replace("/", "").replace("-", " ");
	      title = "" + capitalize(category);
	    }
	    return title;
	  };
	
	  MainLayout.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement("meta", { name: "description", content: _SiteConfig2.default.siteDescription })
	      ),
	      children()
	    );
	  };
	
	  return MainLayout;
	}(_react2.default.Component);
	
	exports.default = MainLayout;
	module.exports = exports["default"];

/***/ }),

/***/ 610:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-jsx-a0cf5c8ab0326594b474.js